import {
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import ROLES_DESCRIPTIONS from '@pages/teamMember/constants/rolesDescriptions';
import { useTranslation } from 'react-i18next';
import TeamRolesDescriptionStyles from './TeamRolesDescription.style';

const TeamRolesDescription = () => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent>
        <List className={TeamRolesDescriptionStyles.list}>
          {ROLES_DESCRIPTIONS.map((role) => (
            <ListItem
              className={TeamRolesDescriptionStyles.listItem}
              key={role.value}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    className={TeamRolesDescriptionStyles.listItemText}
                  >
                    {t(role.label)}
                  </Typography>
                }
                secondary={
                  <Typography
                    variant="caption"
                    className={TeamRolesDescriptionStyles.listItemTextSecondary}
                  >
                    {t(role.description)}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default TeamRolesDescription;
